import { render } from "./LocationRentalPlaces.vue?vue&type=template&id=4715dff1&scoped=true"
import script from "./LocationRentalPlaces.vue?vue&type=script&lang=js"
export * from "./LocationRentalPlaces.vue?vue&type=script&lang=js"

import "./LocationRentalPlaces.vue?vue&type=style&index=0&id=4715dff1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4715dff1"]])

export default __exports__